import { render, staticRenderFns } from "./AmountInputPage.vue?vue&type=template&id=04b9bbe4&scoped=true"
import script from "./AmountInputPage.vue?vue&type=script&lang=js"
export * from "./AmountInputPage.vue?vue&type=script&lang=js"
import style0 from "./AmountInputPage.vue?vue&type=style&index=0&id=04b9bbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9bbe4",
  null
  
)

export default component.exports